import { useMemo } from "react";
import { isOnboardingComplete } from "../../Utils/onboardingNavigation";
import CoachPrivateV2 from "../CoachV2/Private";
import DashboardChat from "../RelationShip/DashboardChat";
import OnboardingQRPage from "./OnboardingQRPage";

function Dashboard() {
  const profile = useMemo(() => {
    try { return JSON.parse(localStorage.getItem("profile") || "{}"); } catch (_) { return {}; }
  }, []);

  const completedSteps = profile?.onboarding_step;
  
  // If onboarding not complete, show QR page with navigation (allows logout)
  if (completedSteps && !isOnboardingComplete(completedSteps)) {
    return <OnboardingQRPage />;
  }

  // Decide which home to render based on coaching_mode
  let mode = profile?.meta_info?.settings?.coaching_mode;
  if (mode !== "voice" && mode !== "keyboard") {
    try {
      const v = localStorage.getItem("coaching_mode");
      if (v === "voice" || v === "keyboard") mode = v;
    } catch (_) {}
  }
  if (mode === "voice") {
    return <CoachPrivateV2 />;
  }
  return <DashboardChat />;
}

export default Dashboard;
